<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" lg="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>
        <spinner v-if="activateSpinner"></spinner>
        <alerts-form :mode="mode" :readonly="!isEditable" v-model="config" v-else></alerts-form>
        <b-row class="justify-content-end">
          <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="switchMode('details')">
              <span>{{ $t('common.cncl') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="switchMode('edit')">
              <i class="fa-light fa-pencil"></i>
              <span>{{ $t('administration.edit') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="deleteAlerts">
              <i class="fa-light fa-trash"></i>
              <span>{{ $t('rights.delete') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="editAlerts">
              <i class="fa-light fa-save"></i>
              <span>{{$t('common.sve')}}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="mode === 'add'">
            <b-button variant="primary"
              @click="addAlerts">
              <i class="fa-light fa-save"></i>
              <span>{{$t('common.sve')}}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import AlertsForm from '@/pages/alerts/AlertsForm.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: "AlertsDetails",
  components: {
    'back-button': backButton,
    'alerts-form': AlertsForm,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    pageTitle() {
      switch (this.mode) {
        case 'edit':
          return this.$t('Webheader.alert_configuration_edit')
        case 'details':
          return this.$t('Webheader.alert_configuration_details')
        case 'add':
        default:
          return this.$t('Webheader.alert_configuration_add')
      }
    }
  },
  data() {
    return {
      activateSpinner: false,
      alerts: '',
      returnUrl: '',
      currentAlerts: {},
      savedConfig: [],
      config: {},
      originalConfig: {},
      formType: 'add'
    }
  },
  created() {
    this.activateSpinner = true
    this.formType = this.mode

    this.returnUrl = '/alerts/'

    if(this.id !== '-1' && (this.mode === "details" || "edit")) {
      this.getAlerts()
    } else {
      this.activateSpinner = false
    }
  },
  methods: {
    addAlerts () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        Name: this.config.Name,
        IdMetricsKey: this.config.IdMetricsKey,
        ThresholdHigh: this.config.ThresholdHigh,
        ThresholdLow: this.config.ThresholdLow,
        IdThresholdUnit: this.config.IdThresholdUnit,
        // desactiver pour lot 1
        // IdEmailGroupName: this.config.selectedGroupNames.map(group => group.id).join(', '),
        Description: this.config.Description,
        Criticality: this.config.Criticality,
        id: this.id
      }
      this.$engine.alerts.create(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.alerts.alert_configuration_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/alerts/'})
      })
      .catch((e) => {
        if (e.response.status === 400 && e.response.data.errors) {
          const errors = e.response.data.errors

          errors.forEach((error) => {
            if (error.error === "Invalid Name") {
              that.okMessageBox(that.$t('common.alerts.name_exist_db'))
            } else if (error.error === "Duplicate Criticality") {
              that.okMessageBox(that.$t('common.alerts.critical_exist_db'))
            }
          })
        } else {
          errorMessageAlert(e, that, that.$i18n)
        }
      })
    },
    deleteAlerts () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.alerts.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdAlerts: that.id
              }
              that.$engine.alerts.delete(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.alerts.alert_configuration_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, {url: '/alerts/'})
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.alerts.alert_configuration_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editAlerts () {

      if (this.formHasError()) {
        return
      }

      let that = this
      let params = {
        Name: this.config.Name,
        IdMetricsKey: this.config.IdMetricsKey,
        ThresholdHigh: this.config.ThresholdHigh,
        ThresholdLow: this.config.ThresholdLow,
        IdThresholdUnit: this.config.IdThresholdUnit,
        // desactiver pour lot 1
        // IdEmailGroupName: this.config.selectedGroupNames.map(group => group.id).join(', '),
        Description: this.config.Description,
        Criticality: this.config.Criticality,
        IdAlerts: this.id
      }
      this.$engine.alerts.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.alerts.alert_configuration_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/alerts/'})
      })
      .catch((e) => {
        if (e.response.status === 400 && e.response.data.errors) {
          const errors = e.response.data.errors

          errors.forEach((error) => {
            if (error.error === "Invalid Name") {
              that.okMessageBox(that.$t('common.alerts.name_exist_db'))
            } else if (error.error === "Duplicate Criticality") {
              that.okMessageBox(that.$t('common.alerts.critical_exist_db'))
            }
          })
        } else {
          errorMessageAlert(e, that, that.$i18n)
        }
      })
    },
    fillFields () {
      this.config = this.currentAlerts
      this.originalConfig = this.currentAlerts
      this.activateSpinner = false
    },
    formHasError () {
      if (this.config.Name === undefined || this.config.length === 0) {
        this.okMessageBox(this.$t('common.alerts.name_missing'))
        return true
      }
      if (this.config.IdMetricsKey === undefined || this.config.length === 0) {
        this.okMessageBox(this.$t('common.alerts.metrics_key_missing'))
        return true
      }
      if (this.config.IdThresholdUnit === undefined || this.config.length === 0) {
        this.okMessageBox(this.$t('common.alerts.threshold_unit_missing'))
        return true
      }
      if (this.config.ThresholdLow === undefined || this.config.length === 0) {
        this.okMessageBox(this.$t('common.alerts.threshold_low_missing'))
        return true
      }
      if (this.config.ThresholdHigh === undefined || this.config.length === 0) {
        this.okMessageBox(this.$t('common.alerts.threshold_high_missing'))
        return true
      }
      // if (this.config.IdEmailGroupName === undefined || this.config.length === 0) {
      //   this.okMessageBox(this.$t('common.email.email_address_missing'))
      //   return true
      // }
      // if (this.config.Description === undefined || this.config.length === 0) {
      //   this.okMessageBox(this.$t('common.alerts.description_missing'))
      //   return true
      // }
      if (this.config.Criticality === undefined || this.config.length === 0) {
        this.okMessageBox(this.$t('common.alerts.criticality_level_missing'))
        return true
      }
      return false
    },
    getAlerts () {
      this.$engine.alerts.fetch({id: this.id})
      .then(resp => {
        let that = this
        let alertsList = {}

        alertsList = resp.data.Alerts

        that.updateAlerts(alertsList)
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchMode (mode) {
      if (mode === 'details' && this.formType === 'edit') {
        this.config = this.originalConfig
      }
      this.formType = mode
    },
    updateAlerts(alertsList){
      const selectedAlerts = alertsList.find(alerts => alerts.IdAlerts === this.id)
      this.currentAlerts = selectedAlerts
      this.fillFields()
    }
  }
}
</script>
